import { capitalize } from '@material-ui/core';
import { A2APayment, CardPayment } from '@nemuru-eng/js-api-client';

import { SinglePaymentProviderLogo } from '@/components/modules/Application/components/PaymentMethod/_shared/components/SinglePaymentProviderLogo';
import { ContrastedCard } from '@/components/shared/components/ContrastedCard';
import { Font } from '@/components/shared/components/Font';
import { IconHeader } from '@/components/shared/components/IconHeader';

interface SinglePaymentProviderProps {
  singlePayment: CardPayment | A2APayment;
}

export const SinglePaymentProvider = ({ singlePayment }: SinglePaymentProviderProps) => {
  return (
    <>
      <IconHeader
        labelTid={'PROVIDER'}
        surLabelTid={'SINGLE_PAYMENT'}
        iconName={'account_balance'}
        color={'secondary'}
        boxProps={{ pb: 4 }}
      />
      <ContrastedCard boxProps={{ minHeight: '64px' }}>
        <Font variant="subtitle1" color="textSecondary">
          <strong>{capitalize(singlePayment.provider)}</strong>
        </Font>
        <SinglePaymentProviderLogo size={80} providers={[singlePayment.provider]} />
      </ContrastedCard>
    </>
  );
};
